import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  serviceContainer: {
    pt: '15px',
  },
  cardContainer: { backgroundColor: 'white', borderRadius: '10px' },
  summaryContainer: { paddingBottom: 1, border: 'none' },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
